import * as React from "react";
import styles from "./Category.module.scss";
import { getDomainDisplayName, faultComparator, createElementKey } from "../../utils/utils";
import FaultListGroupIcon from "../icons/FaultListGroup";
import FaultListItem from "../FaultListItem/FaultListItem";
import _ from "lodash";

type CategoryProps = {
  groupItem: Api.AnyFault;
  childItems: Api.AnyFault[];
  faultPriorities: Api.FaultPriority[];
  faultDomains: Api.Domains;
  onItemClick: (
    resultType: number,
    code: any,
    domainId: any,
    inElectrification?: number,
    inCategory?: number
  ) => void;
  selectedFault: Api.AnyFault | null;
  domain: Api.Domain;
  eleEnumValue?: number;
};

const Category: React.FC<CategoryProps> = (props: CategoryProps) => {
  const {
    groupItem,
    childItems,
    faultPriorities,
    faultDomains,
    onItemClick,
    selectedFault,
    domain,
    eleEnumValue
  } = props;

  const domainsAsArray = _.values(faultDomains);
  const childrenFaultElements = childItems
    .sort(faultComparator(domainsAsArray))
    .map((fault: Api.AnyFault) => {
      // get priority data from id  for fault
      const faultPriority: any = faultPriorities.filter(
        (priority: any) => priority.id === fault.priority?.id
      )[0];
      // get domain data from id for fault
      const faultDomain: any = domainsAsArray.filter(
        (domain: any) => domain.id === fault.domain?.id
      )[0];

      return (
        <FaultListItem
          selected={
            selectedFault?.code === fault.code &&
            selectedFault?.domain?.id === fault.domain?.id &&
            selectedFault?.inElectrification == fault.inElectrification
          }
          key={createElementKey(eleEnumValue, undefined, undefined, fault.id)}
          fault={fault}
          priority={faultPriority}
          domain={faultDomain}
          onItemClick={onItemClick}
        />
      );
    });

  return (
    <div className={styles.Category}>
      <div className={styles.CategoryTitleDiv}>
        <div className={styles.TitleSymbolDiv}>
          <FaultListGroupIcon />
        </div>
        <div className={styles.TitleDetailsDiv}>
          <h2>{groupItem.code}</h2>
          <div className={styles.TitleDetailsFlex}>
            <span>{getDomainDisplayName(domain) + " (" + domain?.enumValue + ")"}</span>
            <span>{groupItem.name}</span>
          </div>
        </div>
        <div className={`${styles.TitleInfoDiv} info`} style={{ color: "#0071B9" }}>
          Category
        </div>
      </div>
      <div className={styles.CategoryBodyDiv}>
        <div>{childrenFaultElements}</div>
      </div>
    </div>
  );
};

export default Category;
